import { InputConfig } from "@cpj-ai/panel-npm-package";
import { AuthAccountCanadaVisaStatusChoices, AuthAccountProfileGenderChoices } from "@graphql/generated";
import { isValidPhoneNumber } from "libphonenumber-js";

export const getInputConfig = (countryCode?: string | null): InputConfig[] => [
  {
    name: "firstName",
    previewSize: {
      sm: 12,
      md: 6,
    },
    inputProps: {
      type: "text",
      label: "First Name:",
      placeholder: "Enter your first name",
    },
    rules: {
      required: "First Name is required",
      maxLength: {
        value: 30,
        message: "First Name is too long",
      },
      pattern: {
        value: /^[a-zA-Z\s]+$/,
        message: "First Name must contain only English letters",
      },
    },
  },
  {
    name: "lastName",
    previewSize: {
      sm: 12,
      md: 6,
    },
    inputProps: {
      type: "text",
      label: "Last Name:",
      placeholder: "Enter your last name",
    },
    rules: {
      required: "Last Name is required",
      maxLength: {
        value: 30,
        message: "Last Name is too long",
      },
      pattern: {
        value: /^[a-zA-Z\s]+$/,
        message: "Last name must contain only English letters",
      },
    },
  },
  {
    name: "gender",
    previewSize: 12,
    inputProps: {
      type: "searcher",
      label: "Gender:",
      placeholder: "Select your gender",
      labelKey: "label",
      valueKey: "value",
      items: [
        { label: "Male", value: AuthAccountProfileGenderChoices.MALE },
        { label: "Female", value: AuthAccountProfileGenderChoices.FEMALE },
        { label: "Not Applicable", value: AuthAccountProfileGenderChoices.NOT_APPLICABLE },
        { label: "Not Known", value: AuthAccountProfileGenderChoices.NOT_KNOWN },
      ],
    },
    rules: {
      required: "Gender is required",
    },
  },
  {
    name: "phone",
    previewSize: 12,
    inputProps: {
      type: "phone",
      label: "Phone Number:",
      placeholder: "Enter your phone number",
    },
    rules: {
      required: "Phone number is required",
      validate: (value) => {
        if (!value) return "Phone number is required";
        return isValidPhoneNumber(value) ? true : "Please enter a valid phone number";
      },
    },
  },
  ...(countryCode === "CA"
    ? [
        {
          name: "visaStatus",
          previewSize: 12,
          inputProps: {
            type: "searcher" as const,
            label: "Visa Status in Canada:",
            placeholder: "Select your visa status",
            labelKey: "label",
            valueKey: "value",
            items: [
              { label: "Citizenship", value: AuthAccountCanadaVisaStatusChoices.CITIZENSHIP },
              {
                label: "Electronic Travel Authorization (eTA)",
                value: AuthAccountCanadaVisaStatusChoices.ELECTRONIC_TRAVEL_AUTHORIZATION,
              },
              {
                label: "International Experience Canada (IEC)",
                value: AuthAccountCanadaVisaStatusChoices.INTERNATIONAL_EXPERIENCE_CANADA,
              },
              { label: "Permanent Resident (PR)", value: AuthAccountCanadaVisaStatusChoices.PERMANENT_RESIDENT },
              { label: "Refugee (Work Permit)", value: AuthAccountCanadaVisaStatusChoices.REFUGEE_WORK_PERMIT },
              {
                label: "Seasonal Agricultural Worker Program (SAWP)",
                value: AuthAccountCanadaVisaStatusChoices.SEASONAL_AGRICULTURAL_WORKER_PROGRAM,
              },
              {
                label: "Temporary Resident (Close Work Permit)",
                value: AuthAccountCanadaVisaStatusChoices.TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT,
              },
              {
                label: "Temporary Resident (Open Work Permit)",
                value: AuthAccountCanadaVisaStatusChoices.TEMPORARY_RESIDENT_OPEN_WORK_PERMIT,
              },
              {
                label: "Temporary Resident (Study Permit)",
                value: AuthAccountCanadaVisaStatusChoices.TEMPORARY_RESIDENT_STUDY_PERMIT,
              },
              { label: "Visitor Visa", value: AuthAccountCanadaVisaStatusChoices.VISITOR_VISA },
              { label: "No Visa", value: AuthAccountCanadaVisaStatusChoices.NO_VISA },
            ],
          },
          rules: {
            required: "Visa status is required",
          },
        },
      ]
    : []),
];
